import { api } from "@/builders/axios";

const get = function (id: number) {
  return api
    .get<{
      points: number;
    }>(`/action-points/${id}`)
    .then(({ data }) => data);
};

const put = function (id: number, data: { points: number }) {
  return api.put(`/action-points/${id}`, data);
};

const patch = function (id: number, data: { points: number }) {
  return api.patch(`/action-points/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/action-points/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
